<template>
  <div class="main-container">
    <!-- 左侧导航 -->
    <div class="sidebar">
      <!-- 顶部圆形图标 -->
      <div class="logo-container">
        <div class="logo-glow"></div>
        <img :src="shopLogo" alt="商户端" class="logo-img" />
        <h1 class="logo-title" v-if="!isCollapse">{{ shopName }}</h1>
      </div>

      <!-- 左侧导航（全部一级项） -->
      <el-menu class="nav-menu" :default-active="activeMenu" :background-color="menuBgColor" text-color="#a0a8c0"
        active-text-color="#7d5fff" router :collapse="isCollapse" unique-opened>


        <!-- —— 小说四个入口：已改为一级 —— -->
        <el-menu-item index="/novel/worddashboard">
          <el-icon>
            <DataAnalysis />
          </el-icon>
          <span>小说大屏</span>
        </el-menu-item>

        <el-menu-item index="/novel/studiopipeline">
          <el-icon>
            <EditPen />
          </el-icon>
          <span>创建小说</span>
        </el-menu-item>


        <el-menu-item index="/novel/novellist">
          <el-icon>
            <List />
          </el-icon>
          <span>小说详情</span>
        </el-menu-item>

        <el-menu-item index="/novel/novelstudio">
          <el-icon>
            <VideoPlay />
          </el-icon>
          <span>直播小说</span>
        </el-menu-item>

        <el-menu-item index="/novel/wordreport">
          <el-icon>
            <Tickets />
          </el-icon>
          <span>消费记录</span>
        </el-menu-item>


        <!-- 素材管理 -->
        <el-sub-menu index="/material">
          <template #title>
            <el-icon>
              <Picture />
            </el-icon>
            <span>素材管理</span>
          </template>

          <el-menu-item index="/material/gallery">
            <el-icon>
              <Picture />
            </el-icon>
            <span>图库管理</span>
          </el-menu-item>

          <el-menu-item index="/material/video-sc">
            <el-icon>
              <Camera />
            </el-icon>
            <span>视频管理</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 系统配置子菜单 -->
        <el-sub-menu index="/system">
          <template #title>
            <el-icon>
              <Setting />
            </el-icon>
            <span>系统配置</span>
          </template>

          <el-menu-item index="/system/systemaiconfig" v-if="moduleStatus.ai_agent === 2">
            <el-icon>
              <Cpu />
            </el-icon>
            <span>创作模型</span>
          </el-menu-item>

          <el-menu-item index="/system/OssConfig" v-if="moduleStatus.storage_config === 2">
            <el-icon>
              <FolderChecked />
            </el-icon>
            <span>存储配置</span>
          </el-menu-item>

          <el-menu-item index="/system/publish">
            <el-icon>
              <SetUp />
            </el-icon>
            <span>基础设置</span>
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>

    <!-- 右侧内容区 -->
    <div class="content-wrapper">
      <!-- 固定在顶部的导航栏 -->
      <div class="top-navbar fixed-top">
        <div class="nav-center">
          <!-- 修改点数显示 -->
          <div class="info-item points">
            <el-icon class="icon">
              <Star />
            </el-icon>
            <span class="label">点数:</span>
            <span class="value">{{ pointsDisplay }}</span>
          </div>

          <!-- 字数显示已经使用 wordCountDisplay -->
          <div class="info-item words">
            <el-icon class="icon">
              <Key />
            </el-icon>
            <span class="label">字数:</span>
            <span class="value">{{ wordCountDisplay }}</span>
          </div>
          <div class="info-item expire">
            <el-icon class="icon">
              <Calendar />
            </el-icon>
            <span class="label">过期时间:</span>
            <span class="value">{{ formattedOutDate }}</span>
          </div>
        </div>

        <div class="nav-right">
          <el-dropdown trigger="hover">
            <div class="user-info">
              <el-avatar :size="30" :src="userAvatar" />
              <span class="username">{{ username }}</span>
              <el-icon class="arrow-icon">
                <ArrowDown />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="showCardRechargeDialog">
                  <el-icon>
                    <CreditCard />
                  </el-icon>卡密充值
                </el-dropdown-item>
                <el-dropdown-item @click="handleModifyPassword">
                  <el-icon>
                    <Edit />
                  </el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided @click="handleLogout">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <!-- 主内容区 -->
      <div class="main-content-container">
        <div class="content-border-top"></div>
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>

  <!-- 卡密充值对话框 -->
  <el-dialog v-model="showCardDialog" title="卡密充值" width="400px" :close-on-click-modal="false" class="tech-dialog">
    <el-form :model="cardForm" label-width="80px">
      <el-form-item label="卡密">
        <el-input v-model="cardForm.code" placeholder="请输入充值卡密" class="tech-input" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button class="tech-btn-cancel" @click="showCardDialog = false">取 消</el-button>
      <el-button class="tech-btn-confirm" @click="submitCardRecharge">确 定</el-button>
    </template>
  </el-dialog>

  <el-dialog v-model="showPasswordDialog" title="修改密码" width="400px" :close-on-click-modal="false" class="tech-dialog">
    <el-form :model="form" label-width="80px">
      <el-form-item label="旧密码">
        <el-input v-model="form.oldPwd" type="password" placeholder="请输入旧密码" show-password class="tech-input" />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="form.newPwd" type="password" placeholder="请输入新密码" show-password class="tech-input" />
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input v-model="form.confirmPwd" type="password" placeholder="请再次输入新密码" show-password class="tech-input" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button class="tech-btn-cancel" @click="showPasswordDialog = false">取 消</el-button>
      <el-button class="tech-btn-confirm" @click="submitPassword">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {
  VideoPlay,
  Picture,
  Setting,
  Cpu,
  CreditCard,
  Camera,
  FolderChecked,
  SetUp,
  // 新增图标
  DataAnalysis,
  List,
  EditPen,
  Tickets,
  // 顶栏用到的
  Star,
  Key,
  Calendar,
  Edit,
  SwitchButton,
  ArrowDown
} from '@element-plus/icons-vue'
import { ref, computed, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import config from '@/config'
import axios from 'axios'

export default {
  name: 'MainLayout',
  components: {
    VideoPlay,
    Picture,
    Setting,
    Cpu,
    CreditCard,
    Camera,
    FolderChecked,
    SetUp,
    DataAnalysis,
    List,
    EditPen,
    Tickets,
    Star,
    Key,
    Calendar,
    Edit,
    SwitchButton,
    ArrowDown
  },
  setup() {
    const router = useRouter()
    const moduleStatus = ref({
      tweet_template: 2,
      writing_model: 2,
      media_model: 2,
      title_api: 2,
      ai_agent: 2,
      storage_config: 2
    })

    const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
    const account = userInfo.account || ''
    const isLoggedIn = ref(!!Cookies.get('user_token'))

    const shopLogo = ref('@/assets/logo.gif')
    const shopName = ref('商户端')
    const menuBgColor = ref('transparent')
    const isCollapse = ref(false)

    const points = ref(0)           // 点数
    const wordCount = ref(0)        // 字数（余额，la_store_user.word_count）
    const outDate = ref('')

    const formattedOutDate = computed(() => outDate.value.split(' ')[0] || '未设置')
    const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
    const username = ref(account)

    // 重要：菜单高亮用当前完整路径
    const activeMenu = computed(() => router.currentRoute.value.path)

    const wordCountDisplay = computed(() => {
      const num = parseInt(wordCount.value || 0, 10)
      // 如果字数为-1，显示"无限制"
      if (num === -1) return '无限制'
      // 否则显示千分位格式
      return num.toLocaleString()
    })

    // 修改后的点数显示（保持一致性）
    const pointsDisplay = computed(() => {
      return points.value === -1 ? '无限制' : points.value.toFixed(1)
    })

    const showPasswordDialog = ref(false)
    const form = reactive({
      oldPwd: '',
      newPwd: '',
      confirmPwd: ''
    })
    const showCardDialog = ref(false)
    const cardForm = reactive({ code: '' })

    const showCardRechargeDialog = () => {
      cardForm.code = ''
      showCardDialog.value = true
    }

    const fetchModuleStatus = async () => {
      try {
        const { data } = await axios.post(`${config.BASE_URL}/shop/api/module_hidden.php`, {
          store_id: userInfo.id
        })
        if (data?.data) moduleStatus.value = data.data
      } catch (e) {
        console.error('获取模块权限失败:', e)
        moduleStatus.value = {
          tweet_template: 2,
          writing_model: 2,
          media_model: 2,
          title_api: 2,
          ai_agent: 2,
          storage_config: 2
        }
      }
    }

    // 加载余额/时间等
    const loadPoints = async () => {
      try {
        const { data } = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'query',
          account
        })
        if (data?.success) {
          points.value = parseFloat(data.data?.dianshu || 0)
          // 这里改为读取后端 word_count
          wordCount.value = parseInt(data.data?.word_count || 0, 10)
          outDate.value = data.data?.out_date || ''
        } else {
          ElMessage.error('点数加载失败: ' + (data?.message || '未知错误'))
        }
      } catch (err) {
        ElMessage.error('接口请求失败: ' + err.message)
      }
    }

    // 修改密码
    const submitPassword = async () => {
      if (!form.oldPwd) return ElMessage.error('请输入旧密码')
      if (!form.newPwd) return ElMessage.error('请输入新密码')
      if (form.newPwd !== form.confirmPwd) return ElMessage.error('两次输入的新密码不一致')

      try {
        const { data } = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'update_password',
          account,
          old_password: form.oldPwd,
          new_password: form.newPwd
        })
        if (data?.success) {
          ElMessage.success('密码修改成功，请重新登录')
          Cookies.remove('user_token')
          router.push('/login')
        } else {
          ElMessage.error(data?.message || '密码修改失败')
        }
      } catch (e) {
        ElMessage.error(e?.response?.data?.message || '请求失败')
      } finally {
        showPasswordDialog.value = false
      }
    }

    const handleModifyPassword = () => {
      Object.assign(form, { oldPwd: '', newPwd: '', confirmPwd: '' })
      showPasswordDialog.value = true
    }

    const loadShopInfo = async () => {
      try {
        const { data } = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`)
        if (data?.success) {
          shopLogo.value = data.data?.shop_logo || '@/assets/logo.gif'
          shopName.value = data.data?.shop_name || '商户端'
        }
      } catch (e) {
        console.error('加载店铺信息失败:', e)
        shopLogo.value = '@/assets/logo.gif'
        shopName.value = '商户端'
      }
    }

    onMounted(() => {
      loadPoints()
      loadShopInfo()
      fetchModuleStatus()
    })

    const handleNavClick = (type) => {
      const messages = {
        distribution: '分销中心正在开发中，请稍后...',
        discount: '优惠套餐正在开发中，请稍后...'
      }
      ElMessage.info(messages[type] || '功能开发中')
    }

    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )
        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false
        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        if (error !== 'cancel') ElMessage.error('退出操作失败，请重试')
      }
    }

    return {
      menuBgColor,
      isCollapse,
      points,
      wordCount,
      pointsDisplay, // 添加这个
      wordCountDisplay,
      userAvatar,
      username,
      activeMenu,
      formattedOutDate,
      handleLogout,
      handleNavClick,
      showPasswordDialog,
      form,
      showCardDialog,
      cardForm,
      showCardRechargeDialog,
      submitCardRecharge: async () => {
        if (!cardForm.code) return ElMessage.error('请输入卡密')
        try {
          const { data } = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
            action: 'recharge_card',
            store_id: userInfo.id,
            code: cardForm.code
          })
          if (data?.success) {
            ElMessage.success('充值成功')
            await loadPoints()
            showCardDialog.value = false
          } else {
            ElMessage.error(data?.message || '充值失败')
          }
        } catch (e) {
          ElMessage.error(e?.response?.data?.message || '请求失败')
        }
      },
      submitPassword,
      shopLogo,
      shopName,
      moduleStatus,
      userInfo,
      handleModifyPassword
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  display: flex;
  background: #f8f9fa;
  color: #333;
  min-height: 100vh;
  position: relative;
}

/* 左侧导航栏 */
.sidebar {
  width: 220px;
  background: #2c3e50;
  position: relative;
  z-index: 10;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  .logo-container {
    position: relative;
    padding: 24px 0;
    margin-bottom: 15px;
    text-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    .logo-img {
      width: 64px;
      height: 64px;
      border: 2px solid rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s;
      object-fit: cover;
      background: rgba(255, 255, 255, 0.1);
      padding: 5px;
    }

    .logo-title {
      margin: 18px 0 0;
      font-size: 18px;
      font-weight: 600;
      color: #fff;
      letter-spacing: 1px;
    }
  }
}

.nav-menu {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: rgba(255, 255, 255, 0.1);
  padding: 12px 8px;
  height: auto;

  :deep(.el-icon) {
    color: #ecf0f1 !important;
  }

  :deep(.el-submenu__title),
  :deep(.el-menu-item) {
    height: 48px;
    margin: 4px 0;
    border-radius: 6px;
    transition: all 0.3s;
    padding: 0 20px !important;
    display: flex !important;
    align-items: center;
    color: #ecf0f1;

    .el-icon {
      font-size: 18px;
      flex-shrink: 0;
      width: 24px;
      margin-right: 11px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.15) !important;
      color: #fff;
    }
  }

  :deep(.el-menu-item.is-active) {
    background: rgba(52, 152, 219, 0.2) !important;
    color: #fff !important;
    border-left: 3px solid #3498db;
  }

  :deep(.el-sub-menu) {
    .el-menu-item {
      padding-left: 50px !important;
    }

    .el-menu-item.is-active {
      padding-left: 48px !important;
    }
  }
}

/* 右侧内容区 */
.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  position: relative;
}

.fixed-top {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 64px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid #eee;

  .nav-center {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-left: auto;

    .info-item {
      display: flex;
      align-items: center;
      padding: 8px 15px;
      border-radius: 8px;
      font-size: 14px;
      transition: all 0.3s;
      background: #f8f9fa;
      border: 1px solid #eee;

      .icon {
        font-size: 16px;
        margin-right: 8px;
      }

      .label {
        font-weight: 500;
        margin-right: 4px;
        color: #7f8c8d;
      }

      .value {
        font-weight: 600;
        color: #2c3e50;
      }

      &.points {
        background: rgba(52, 152, 219, 0.1);
        border-color: rgba(52, 152, 219, 0.2);

        .icon {
          color: #3498db;
        }
      }

      /* 把授权数换成字数 */
      &.words {
        background: rgba(46, 204, 113, 0.1);
        border-color: rgba(46, 204, 113, 0.2);

        .icon {
          color: #2ecc71;
        }
      }

      &.expire {
        background: rgba(241, 196, 15, 0.1);
        border-color: rgba(241, 196, 15, 0.2);

        .icon {
          color: #f1c40f;
        }
      }
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.3s;
    cursor: pointer;
    background: #f8f9fa;
    border: 1px solid #eee;

    &:hover {
      background: #eee;
    }

    .username {
      margin-left: 12px;
      font-size: 14px;
      font-weight: 500;
      color: #2c3e50;
    }

    .arrow-icon {
      margin-left: 6px;
      color: #7f8c8d;
      font-size: 12px;
    }
  }
}

.main-content-container {
  position: relative;
  padding: 0px;
  background: #fff;

  .main-content {
    background: #fff;
    min-height: calc(100vh - 84px);
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.03);
    border: 1px solid #eee;
    position: relative;
    overflow: hidden;
  }
}

/* 对话框样式 */
:deep(.el-dialog) {
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);

  .el-dialog__header {
    border-bottom: 1px solid #eee;
    margin-right: 0;
    padding: 15px 20px;
    background: #f8f9fa;

    .el-dialog__title {
      color: #2c3e50;
      font-weight: 600;
    }
  }

  .el-dialog__body {
    padding: 20px;
    background: #fff;
    color: #333;
  }

  .el-dialog__footer {
    border-top: 1px solid #eee;
    padding: 15px 20px;
    background: #f8f9fa;
  }
}

:deep(.el-input__wrapper) {
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: none;

  &:hover {
    border-color: #3498db;
  }

  &:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 1px #3498db;
  }
}

:deep(.el-button) {
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.25s;

  &.el-button--default {
    background: #f8f9fa;
    border-color: #ddd;
    color: #333;

    &:hover {
      background: #eee;
      border-color: #ccc;
    }
  }

  &.el-button--primary {
    background: #3498db;
    border-color: #3498db;

    &:hover {
      background: #2980b9;
      border-color: #2980b9;
    }
  }
}

:deep(.el-menu) {
  border-right: none !important;
}

/* 主内容区 */
.main-content-container {
  position: relative;
  padding: 0px;
  background: #fff;

  .main-content {
    background: #fff;
    min-height: calc(100vh - 84px);
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.03);
    border: 1px solid #eee;
    position: relative;
    overflow: hidden;
  }
}

/* 对话框样式 */
:deep(.el-dialog) {
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);

  .el-dialog__header {
    border-bottom: 1px solid #eee;
    margin-right: 0;
    padding: 15px 20px;
    background: #f8f9fa;

    .el-dialog__title {
      color: #2c3e50;
      font-weight: 600;
    }
  }

  .el-dialog__body {
    padding: 20px;
    background: #fff;
    color: #333;
  }

  .el-dialog__footer {
    border-top: 1px solid #eee;
    padding: 15px 20px;
    background: #f8f9fa;
  }
}

:deep(.el-input__wrapper) {
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: none;

  &:hover {
    border-color: #3498db;
  }

  &:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 1px #3498db;
  }
}

:deep(.el-button) {
  &.el-button--default {
    background: #f8f9fa;
    border-color: #ddd;
    color: #333;

    &:hover {
      background: #eee;
      border-color: #ccc;
    }
  }

  &.el-button--primary {
    background: #3498db;
    border-color: #3498db;

    &:hover {
      background: #2980b9;
      border-color: #2980b9;
    }
  }
}

:deep(.el-menu) {
  border-right: none !important;
}

:deep(.el-button) {
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.25s;

  &.el-button--default {
    background: #1a1c2f;
    border-color: #25283d;
    color: #a1a8c3;

    &:hover {
      background: #25283d;
      border-color: #6576ff;
      color: #fff;
    }
  }

  &.el-button--primary {
    background: linear-gradient(90deg, #6576ff 0%, #9a67ff 100%);
    border: none;
    box-shadow: 0 4px 15px rgba(101, 118, 255, 0.3);
    color: #fff;
    text-shadow: 0 0 5px rgba(101, 118, 255, 0.5);

    &:hover {
      background: linear-gradient(90deg, #5a6ae8 0%, #8a5ae8 100%);
      box-shadow: 0 6px 20px rgba(101, 118, 255, 0.4);
      transform: translateY(-1px);
    }
  }
}
</style>
